import React from "react";
import BounceLoader from "react-spinners/BounceLoader";
import PulseLoader from "react-spinners/PulseLoader";

export default (props) => {
  const { color = "#000000" } = props;
  return <BounceLoader size={props?.size || 60} color={color} />;
};

export const ButtonLoader = (props) => {
  return <PulseLoader {...props} />;
};
